import { render } from "./inbox-actions.vue?vue&type=template&id=69725c38"
import script from "./inbox-actions.vue?vue&type=script&lang=js"
export * from "./inbox-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__